// Display formatting for the Sou-Sou wallet card. The server gives the amounts and the dates; nothing is calculated here,
// and the dates are never converted to the viewer's zone (the `local` string is already in the circle's zone).
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const CADENCE = { WEEKLY: 'weekly', BIWEEKLY: 'biweekly', MONTHLY: 'monthly' }

export const formatCents = cents => {
  if (!Number.isInteger(cents) || cents < 0) return null
  const rest = cents % 100
  return `$${Math.floor(cents / 100).toLocaleString('en-US')}${rest ? `.${String(rest).padStart(2, '0')}` : ''}`
}

// 'Sep 7' (the year is added only when it is not the current one)
export const formatDay = (zoned, currentYear = new Date().getFullYear()) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(zoned?.local || '')
  if (!match) return null
  const month = MONTHS[Number(match[2]) - 1]
  if (!month) return null
  return `${month} ${Number(match[3])}${Number(match[1]) === currentYear ? '' : `, ${match[1]}`}`
}

export const describeItem = (item, currentYear) => {
  const hand = formatCents(item.handCents)
  const cadence = CADENCE[item.cadence]
  const first = formatDay(item.firstDrawAt, currentYear)
  // only a paused circle is named: the Archive tab already says completed/cancelled (and a cancelled circle is not "paused")
  const state = item.isPaused && (item.status === 'ENROLLING' || item.status === 'ACTIVE') ? 'Paused' : null
  return [
    state,
    hand && cadence ? `${hand} ${cadence}` : hand,
    Number.isInteger(item.periods) ? `${item.periods} ${item.periods === 1 ? 'draw' : 'draws'}` : null,
    first ? `first draw ${first}` : null,
  ].filter(Boolean).join(' · ')
}
